import { SiteShell } from "@/components/site/SiteShell";
import { PageHero } from "@/components/site/PageHero";
import { SEO, breadcrumbSchema } from "@/components/site/SEO";
import { ROUTE_SEO } from "@/lib/routeSeo";
import { ContactCTA } from "@/components/site/ContactCTA";
import { GMBSection } from "@/components/site/GMBSection";
import { CalendlyInline } from "@/components/site/CalendlyEmbed";
import { ReviewsSection } from "@/components/site/ReviewsSection";

export default function Contact() {
  return (
    <SiteShell>
      <SEO title={ROUTE_SEO["/contact"].title} description={ROUTE_SEO["/contact"].meta} path="/contact" jsonLd={[breadcrumbSchema([{name: "Home", path: "/"}, {name: "Contact"}])]} />
      <PageHero kicker="Contact" title={ROUTE_SEO["/contact"].h1} subtitle="Send us a short brief or book a 15-min call - we'll come back with a creative response, treatment direction and a clear estimate. Free, no commitment." breadcrumb={[{name: "Home", path: "/"}, {name: "Contact"}]} />

      <section className="pt-2 pb-0" data-testid="contact-bakery-note">
        <div className="container-site">
          <p className="text-xs text-muted-foreground max-w-3xl">
            Pie in the Sky Productions is a Cape Town film &amp; video production company. Looking for the bakery? Visit{" "}
            <a href="https://pie-in-the-sky.co.za" target="_blank" rel="noreferrer noopener" className="underline underline-offset-4 hover:text-foreground transition-colors">pie-in-the-sky.co.za</a>.
          </p>
        </div>
      </section>
      <ContactCTA />
      <ReviewsSection
        kicker="Trusted by clients"
        title="Read what people say before you write to us."
        subtitle="Live Google reviews from clients we've worked with across South Africa and beyond."
      />
      <CalendlyInline kicker="Book a strategy call" title="Pick a slot - 15 minutes, no pressure." subtitle="Prefer to talk it through? Grab a slot below and we'll discuss your project together." />
      <GMBSection />
    </SiteShell>
  );
}
